import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CourseLandingScreen from '../../../components/courseLandingScreen';
import bannerImage from '../../../images/ComponentImages/banner02.png';
import CourseDescription from '../../../components/courseDescription';
import WarningBlock from '../../../components/warningBlock';
import CourseDescriptionV2 from '../../../components/courseDescriptionV2';
import CourseDescriptionV2Image from '../../../images/ComponentImages/CourseDescriptionV201.png';
import Banner from '../../../components/banner';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CourseLandingScreen title='Sculpture' />
			<CourseDescription
				mt={true}
				title='Intro to Sculpture'
				texts={[
					'Sculpture is a program created for you to strictly build muscle, change your frame, and make an internal/external difference to your body and well-being',
					'You have to understand that you aren’t just a person that goes to the gym. You are an artist; you have the responsibility to start working on yourself. It will take great courage and discipline to start changing your      own self. Sculpture is based on how much you are putting in each set, each rep, each minute and each second!',
				]}
			/>
			<Banner mt={true} bgImage={bannerImage} title={'There is always room for improvement.'} alignment='left' />
			<WarningBlock
				mt={true}
				texts={[
					'“The Sculpture Program requires a Gym or a Workout Setup with standard gym equipment to be able to perform the program exercises properly.”',
				]}
			/>
			<CourseDescriptionV2
				mt={true}
				title={'Utmost Disipline'}
				texts={[
					'You think you just stroll to the gym, just pick up a weight, go through the motions, and then just leave thinking you are done. NO! What you are really doing is picking up the chisel, sculpting on your project, and the project is YOU, so you need to put 100% effort when performing your set. You will be grading yourself consistently, determining what your weak points are, self-reflection, and visualizing the outcome for your future.',
					'In the Sculpture program, you’ll need to use various exercises(tools) to work on different types of muscle groups hitting them at all angles. This creates a stimulant to the muscle for it to grow causing HYPERTROPHY.',
				]}
				bgImage={CourseDescriptionV2Image}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
